/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssistitoContattoDTO
 */
export interface AssistitoContattoDTO {
    /**
     * 
     * @type {string}
     * @memberof AssistitoContattoDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoContattoDTO
     */
    cognome?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoContattoDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoContattoDTO
     */
    tipoContattoId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoContattoDTO
     */
    tipoContatto?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoContattoDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoContattoDTO
     */
    telefono?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoContattoDTO
     */
    cellulare?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoContattoDTO
     */
    note?: string;
}

/**
 * Check if a given object implements the AssistitoContattoDTO interface.
 */
export function instanceOfAssistitoContattoDTO(value: object): value is AssistitoContattoDTO {
    return true;
}

export function AssistitoContattoDTOFromJSON(json: any): AssistitoContattoDTO {
    return AssistitoContattoDTOFromJSONTyped(json, false);
}

export function AssistitoContattoDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistitoContattoDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'cognome': json['cognome'] == null ? undefined : json['cognome'],
        'nome': json['nome'] == null ? undefined : json['nome'],
        'tipoContattoId': json['tipoContattoId'] == null ? undefined : json['tipoContattoId'],
        'tipoContatto': json['tipoContatto'] == null ? undefined : json['tipoContatto'],
        'email': json['email'] == null ? undefined : json['email'],
        'telefono': json['telefono'] == null ? undefined : json['telefono'],
        'cellulare': json['cellulare'] == null ? undefined : json['cellulare'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function AssistitoContattoDTOToJSON(value?: AssistitoContattoDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'cognome': value['cognome'],
        'nome': value['nome'],
        'tipoContattoId': value['tipoContattoId'],
        'tipoContatto': value['tipoContatto'],
        'email': value['email'],
        'telefono': value['telefono'],
        'cellulare': value['cellulare'],
        'note': value['note'],
    };
}

